import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Modal, { StandardModal } from '.';
import { Box, Flex, SxStyleProp } from '../grid';
import Portal from '../portal';
import { ModalWindowProps } from './component';
// import { useStateWithRef } from '../hooks';
// import { iOS } from '../utils/detect';

export interface OpenModalFn {
  (title: string, getContent: (args: {
    close: () => void;
  } & Record<string, any>) => React.JSX.Element, options?: {
    size?: ModalWindowProps['size'];
    onClose?: () => void;
    leftCorner?: React.ReactNode;
    rightCorner?: React.ReactNode;
    type?: 'standard' | 'blank';
    closeWithHookCleanup?: boolean;
    zIndexDelta?: number;
    sx?: SxStyleProp;
  }): () => void;
}
interface ModalToastContextInterface {
  openModal: OpenModalFn;
  modalCount: number;
  setModalCount: React.Dispatch<React.SetStateAction<number>>;
  hasLeftPanel?: boolean;
  hasRightPanel?: boolean;
}
export const ModalToastContext = React.createContext<ModalToastContextInterface>({
  openModal: () => null,
  modalCount: 0,
  setModalCount: (fn: React.SetStateAction<number>) => {},
  hasLeftPanel: false,
  hasRightPanel: false
});

// const isIOS = true; //iOS();

export const ModalToastProvider = t0 => {
  const $ = _c(21);
  const {
    children
  } = t0;
  const [modalCount, setModalCount] = React.useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [modalStack, setModalStack] = React.useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (title, getContent, t3) => {
      const {
        size: t4,
        onClose,
        leftCorner,
        rightCorner,
        type: t5,
        zIndexDelta: t6,
        sx: t7
      } = t3;
      const size = t4 === undefined ? "medium" : t4;
      const type = t5 === undefined ? "standard" : t5;
      const zIndexDelta = t6 === undefined ? 0 : t6;
      const sx = t7 === undefined ? {} : t7;
      const randomId = Math.random().toString(36).substring(7);
      const close = () => {
        onClose?.();
        setModalStack(v => v.filter(m => m.id !== randomId));
      };
      const isDirtyRef = React.createRef();
      const backdropRef = React.createRef();
      const hasUnsavedChanges = () => {
        if (typeof isDirtyRef.current === "function") {
          return isDirtyRef.current();
        }
        return isDirtyRef.current;
      };
      const changeSize = newSize => {
        setModalStack(v_0 => v_0.map(m_0 => {
          if (m_0.id === randomId) {
            return {
              ...m_0,
              size: newSize
            };
          }
          return m_0;
        }));
      };
      const sizeOptions = ["minimized", "right", "full"];
      if (!sizeOptions.includes(size)) {
        sizeOptions.unshift(size);
      }
      const modalItem = {
        id: randomId,
        title,
        content: getContent({
          close,
          isDirtyRef,
          backdropRef,
          changeSize,
          sizeOptions
        }),
        size,
        originalSize: size,
        changeSize,
        sizeOptions,
        close,
        leftCorner,
        rightCorner,
        hasUnsavedChanges,
        backdropRef,
        type,
        zIndexDelta,
        sx
      };
      setModalStack(v_1 => [...v_1, modalItem]);
      return close;
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const openGlobalModal = t2;
  let t3;
  let t4;
  if ($[2] !== modalStack) {
    t4 = modalStack.filter(_temp).map(_temp2);
    $[2] = modalStack;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  t3 = t4;
  const minimizedModals = t3;
  let t5;
  let t6;
  if ($[4] !== modalStack) {
    t6 = modalStack.map(_temp4);
    $[4] = modalStack;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  t5 = t6;
  const modals = t5;
  let t7;
  let t8;
  if ($[6] !== modalStack) {
    t8 = modalStack.some(_temp5);
    $[6] = modalStack;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  t7 = t8;
  const hasLeftPanel = t7;
  let t9;
  let t10;
  if ($[8] !== modalStack) {
    t10 = modalStack.some(_temp6);
    $[8] = modalStack;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  t9 = t10;
  const hasRightPanel = t9;
  let t11;
  let t12;
  if ($[10] !== hasLeftPanel || $[11] !== hasRightPanel || $[12] !== modalCount) {
    t12 = {
      openModal: openGlobalModal,
      modalCount,
      setModalCount,
      hasLeftPanel,
      hasRightPanel
    };
    $[10] = hasLeftPanel;
    $[11] = hasRightPanel;
    $[12] = modalCount;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  t11 = t12;
  const value = t11;
  let t13;
  if ($[14] !== minimizedModals) {
    t13 = minimizedModals.length != 0 && <Portal><Flex sx={{
        position: "fixed",
        bottom: 0,
        right: "355px",
        gap: 2,
        zIndex: 6005
      }}>{minimizedModals}</Flex></Portal>;
    $[14] = minimizedModals;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== children || $[17] !== modals || $[18] !== t13 || $[19] !== value) {
    t14 = <ModalToastContext.Provider value={value}>{children}{modals}{t13}</ModalToastContext.Provider>;
    $[16] = children;
    $[17] = modals;
    $[18] = t13;
    $[19] = value;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  return t14;
};
function _temp(m_1) {
  return m_1.size === "minimized";
}
function _temp2(t0, idx) {
  const {
    id,
    title: title_0,
    changeSize: changeSize_0,
    originalSize
  } = t0;
  return <Box key={id} id={`minimized-modal-${id}`} bg="primary" as="button" type="button" onClick={() => {
    changeSize_0(originalSize);
  }} px={2} py={2} color="invertedText" fontWeight="bold" borderTopLeftRadius={2} borderTopRightRadius={2} data-sentry-element="Box" data-sentry-component="_temp2" data-sentry-source-file="context.tsx">{title_0}</Box>;
}
function _temp3(t0) {
  const {
    content: content_0
  } = t0;
  return content_0;
}
function _temp4(t0) {
  const {
    id: id_0,
    title: title_1,
    content,
    size: size_0,
    close: close_0,
    leftCorner: leftCorner_0,
    rightCorner: rightCorner_0,
    hasUnsavedChanges: hasUnsavedChanges_0,
    backdropRef: backdropRef_0,
    type: type_0,
    zIndexDelta: zIndexDelta_0,
    changeSize: changeSize_1,
    sizeOptions: sizeOptions_0,
    sx: sx_0
  } = t0;
  const ModalComponent = type_0 === "blank" ? Modal : StandardModal;
  return <ModalComponent key={id_0} isOpen={true} close={close_0} title={type_0 !== "blank" ? title_1 : undefined} props={{
    content
  }} size={size_0} leftCorner={leftCorner_0} rightCorner={rightCorner_0} hasUnsavedChanges={hasUnsavedChanges_0} backdropRef={backdropRef_0} zIndexDelta={zIndexDelta_0} changeSize={changeSize_1} sizeOptions={sizeOptions_0} sx={sx_0} data-sentry-element="ModalComponent" data-sentry-component="_temp4" data-sentry-source-file="context.tsx">{_temp3}</ModalComponent>;
}
function _temp5(m_2) {
  return m_2.size === "left";
}
function _temp6(m_3) {
  return m_3.size === "right";
}